import { Component, OnInit, ViewChild, AfterContentInit } from '@angular/core';
import { OrderBatchLogisticsWizardService } from '../../../../services/wizard/logistic/order-batch-send-wizard.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SendOrderLogisticsDetailComponent } from '../send-order-logistics-detail/send-order-logistics-detail.component';
import { WizardStep } from '../../../../wizard/wizard.component';
import { MatTabGroup } from '@angular/material/tabs';
import { SendOrderLogisticsItemComponent } from '../send-order-logistics-item/send-order-logistics-item.component';

@Component({
    selector: 'app-send-order-logistics-wizard',
    templateUrl: './send-order-logistics-wizard.component.html',
    styleUrls: ['./send-order-logistics-wizard.component.css'],
    providers: [{ provide: OrderBatchLogisticsWizardService, useClass: OrderBatchLogisticsWizardService }]
  })

  export class SendOrderLogisticsWizardComponent implements OnInit, AfterContentInit {
    loadingAction: boolean;
    loading: boolean;
    @ViewChild('tabGroup', {static: false}) tabGroup: MatTabGroup;
    @ViewChild('sendOrderLogisticsDetail', {static: false}) sendOrderLogisticsDetail: SendOrderLogisticsDetailComponent;
    @ViewChild('sendOrderLogisticsItem', {static: false}) sendOrderLogisticsItem: SendOrderLogisticsItemComponent;

    constructor(private notificationToastService: NotificationToastService
      , private orderBatchSendWizardService: OrderBatchLogisticsWizardService
      , public router: Router
      , private route: ActivatedRoute)  {
    }

    ngOnInit(): void {
      this.loading = true;
      this.route.params.subscribe(async (params) => {
        try {
          const orderBatchId = params['Id'] ? params['Id'] : null;
          await this.orderBatchSendWizardService.initialize(orderBatchId);
          setTimeout(() => {
            this.sendOrderLogisticsDetail.activate();
          }, 0);
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err), 'Envio de órdenes');
        } finally {
          this.loading = false;
        }
      });
    }

    cancel(): void {
      history.back();
    }

    async save() {
      if (!this.validateSteps(this.getSteps().length - 1)) {
        try {
          this.loadingAction = true;
          if (await this.orderBatchSendWizardService.orderBatchUpdate()) {
            this.cancel();
          }
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err), 'Envio de órdenes');
        } finally {
          this.loadingAction = false;
        }
      }
    }

    async send() {
      if (!this.validateSteps(this.getSteps().length - 1)) {
        try {
          this.loadingAction = true;
          if (await this.orderBatchSendWizardService.orderBatchSend()) {
            this.cancel();
          }
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err), 'Envio de órdenes');
        } finally {
          this.loadingAction = false;
        }
      }
    }

    ngAfterContentInit(): void {

    }

    selectedIndexChange(newIndex: number): void {
      this.validateSteps(newIndex);
      const steps = this.getSteps();
      if (steps.length > newIndex) {
        steps[newIndex].activate();
      }
    }

    private validateSteps(newIndex: number): boolean {
      const steps = this.getSteps();
      let inx = 0;
      let hasError = false;
      while (inx <= newIndex && steps.length > inx && !hasError) {
        hasError = !steps[inx].completed;
        inx = inx + 1;
      }
      if (hasError) {
        this.tabGroup.selectedIndex = inx - 1;
      }
      return hasError;
    }

    private getSteps() {
      const steps: WizardStep[] = [];
      // se tienen que agregar los pasos en el mismo orden que aparecen
      if (this.sendOrderLogisticsDetail
        && this.sendOrderLogisticsDetail.isInit) {
        steps.push(this.sendOrderLogisticsDetail);
      }
      if (this.sendOrderLogisticsItem
        && this.sendOrderLogisticsItem.isInit) {
        steps.push(this.sendOrderLogisticsItem);
      }
      return steps;
    }
}
